import clsx from 'clsx';
import { MenuEditSectionProvider } from '@/features/sports-menu/contexts/menu-edit-section-context';
import { SportsMenu, SubMenu } from '@/features/sports-menu';
import { useCurrentProperties, useCurrentSubMenuItems } from '@/hooks/query';
import { menuBarStyle } from './menu-bar.style';
import { useSiteStore } from '@/store/site';
import { isNumberGames, isVirtualSports } from '@/services/settings.service';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';

export const MenuBar = ({ visible = true }: { visible?: boolean }) => {
	const { sport } = useCurrentProperties();
	const isParlayMode = useSiteStore(state => state.isParlayMode);
	const subMenuItemsOfCurrentSport = useCurrentSubMenuItems(isParlayMode);
	const isShowMenuBar = !isNumberGames(Number(sport));
	const hasSubMenu =
		!isVirtualSports(Number(sport)) &&
		Array.isArray(subMenuItemsOfCurrentSport) &&
		subMenuItemsOfCurrentSport.length > 0;
	const view = useAppearanceStore(state => state.view);
	const isGalaxyView = view === ViewEnum.galaxy;
		
	return (
		isShowMenuBar ? (
			<section className={clsx('sports-menu', menuBarStyle.sportsMenu, {
				'sports-menu--virtual': isGalaxyView && isVirtualSports(Number(sport)),
			})} data-submenu-open={hasSubMenu} data-static={!visible}
			>
				<div className={clsx('sports-menu__container container', menuBarStyle.sportsMenu_container)}>
					<MenuEditSectionProvider>
						<SportsMenu />
					</MenuEditSectionProvider>
				</div>
				{
					!hasSubMenu ? null : <SubMenu items={subMenuItemsOfCurrentSport} />
				}
			</section>
		) : null
	);
};